import * as yup from 'yup';
// import { coverWithinRange } from "../utilities/preQualificationUtils";
import { formatCurrencyNoDecimal } from '../utilities/numericFormat.js';

// import {
//   PERMANENT_DISABILITY_MIN,
//   PERMANENT_DISABILITY_MAX,
// } from "./sharedConstValues.js";

export const permanentDisabilityCover = (person) => {
  const lifeCover = `${person}_lifeCover`;
  const permanentDisability = `${person}_permanentDisabilityCover`;
  const personDetails = person;

  return {
    [`${person}_permanentDisabilityCover`]: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .nullable()
      .test(
        'permanent-disability-cover',
        'Permanently unable to Work cover can’t be selected without Life cover',
        function (value) {
          //* when return is false then the error message is triggered
          return value == null || this.parent[lifeCover] ? true : false;
        },
      )
      .test(
        'permanent-disability-exceed',
        'Permanently Unable to Work Cover Amount can’t exceed the Life Cover Amount',
        function (value) {
          //when return is false then the error message is triggered
          return value == null ? true : value <= this.parent[lifeCover];
        },
      )
      .min(
        yup.ref('$' + personDetails + '_minPUWCover'),
        ({ min }) => `Minimum cover required is ${formatCurrencyNoDecimal(min)}`,
      )
      .max(
        yup.ref('$' + personDetails + '_maxPUWCover'),
        ({ max }) => `Maximum cover required is ${formatCurrencyNoDecimal(max)}`,
      ),
    // [`${person}_occupationList`]: yup
    //   .string()
    //   .when("$" + personDetails + "_validateOccupationList", {
    //     is: true,
    //     then: yup
    //       .string()
    //       .required(
    //         "You must select your occupation type from the occupation list"
    //       ),
    //     otherwise: yup.string().nullable().notRequired(),
    //   })
    //   .test(
    //     "occupationList-select",
    //     "Permanently Unable to Work cover is unavailable for the Occupation Type selected",
    //     function (value) {
    //       //when return is false then the error message is triggered
    //       return value == null ? true : value === "11-U" ? false : true;
    //     }
    //   ),
  };
};
